import { Button, HFlow, Icon, Tooltip } from 'bold-ui'
import React from 'react'
import { EXCLUSAO_DESABILITADA_PROBLEMA_OBRIGATORIO } from 'view/atendimentos/detail/soap/avaliacao/components/problemas-condicoes/utils/messages'

interface ButtonsHeaderProblemaModalProps {
  registradoAgora: boolean
  isCiapW78Automatico: boolean
  isAntecedentes: boolean
  isSituacaoDiferenteDeResolvido: boolean
  isExcluirDisabled: boolean
  handleEditarClick(e: React.MouseEvent<HTMLButtonElement>): void
  handleExcluirClick(e: React.MouseEvent<HTMLButtonElement>): void
}

export function ButtonsHeaderProblemaModal(props: ButtonsHeaderProblemaModalProps) {
  const {
    registradoAgora,
    isCiapW78Automatico,
    isAntecedentes,
    isSituacaoDiferenteDeResolvido,
    isExcluirDisabled,
    handleEditarClick,
    handleExcluirClick,
  } = props

  const getTooltipText = (isEdicao: boolean) => {
    const W78Automatico = `Registro não pode ser ${
      isEdicao ? 'editado' : 'excluído'
    } pois possui relação com condição avaliada de Desfecho de gravidez ou Alto risco`
    const padrao = `${isEdicao ? 'Editar' : 'Excluir'}`
    const LPC = `Para ${isEdicao ? 'editar' : 'excluir'}, acesse o card lateral de Lista de problemas/condições`
    const registroAnterior = `Avaliações do atendimento atual devem ser ${isEdicao ? 'alteradas' : 'excluídas'} no SOAP`

    if (isCiapW78Automatico) {
      return W78Automatico
    }

    if (isExcluirDisabled && !isEdicao) {
      return EXCLUSAO_DESABILITADA_PROBLEMA_OBRIGATORIO
    }

    if (!registradoAgora) {
      return registroAnterior
    }

    if (isAntecedentes && isSituacaoDiferenteDeResolvido) {
      return LPC
    }

    return padrao
  }

  const disabled = !registradoAgora || (isAntecedentes && isSituacaoDiferenteDeResolvido) || isCiapW78Automatico

  return (
    <HFlow justifyContent='flex-end' hSpacing={0.5}>
      <Tooltip text={getTooltipText(true)}>
        <Button size='small' skin='ghost' onClick={handleEditarClick} disabled={disabled}>
          <Icon icon='penOutline' />
        </Button>
      </Tooltip>

      <Tooltip text={getTooltipText(false)}>
        <Button size='small' skin='ghost' onClick={handleExcluirClick} disabled={disabled || isExcluirDisabled}>
          <Icon icon='trashOutline' />
        </Button>
      </Tooltip>
    </HFlow>
  )
}
